module.exports = __webpack_public_path__ + "img/icon3.f9e78a7e.svg";